import { json } from "body-parser";
import React from "react";

export default class Student extends React.Component {
    constructor(props) {
        super(props);
        this.state = ({
            arrA: [],
            DefWs: '',
            choose: 1,
            SeelctWs:[],
            chuesWs:'',
            DefYear: '',
            SeelctYear: [],
            check: 0
        });

        fetch(`/SeelctWs`)
        .then(res => res.json())
        .then(json => this.setState({ SeelctWs: json.SeelctWs}))

        fetch(`/DefWs`)
        .then(res => res.json())
        .then(json => this.setState({ DefWs: json.DefWs})) 

        fetch(`/DefYear`)
        .then(res => res.json())
        .then(json => this.setState({ DefYear: json.DefYear }))

    fetch(`/SeelctYear `)
        .then(res => res.json())
        .then(json => this.setState({ SeelctYear: json.SeelctYear }))
    }
    
   

    getWsTeacher() {
        if (this.state.check == 0) {
            fetch(`/objgetdatas_st?year=${this.state.DefYear}&ws=${this.state.DefWs}&human_id=${this.props.id_student}`)
                .then(res => res.json())
                .then(json => this.setState({
                    arrA: json.OBJ,
                    check: 1
                }
                )
                )
        }

    }


   
    getChange(e) {
        this.setState({
            DefWs: e.target.value,
            check: 0
        });
      
    }
    getChangeYear(e) {
        this.setState({
            DefYear: e.target.value,
            check: 0
        });
    }
 

    render() {
        let SeelctYear = [];
        this.state.SeelctYear.map((year) => {
            if (year.id_a_year == this.state.DefYear) {
                SeelctYear.push(<option selected value={year.id_a_year}>{year.years}</option>)
            } else {
                SeelctYear.push(<option value={year.id_a_year}>{year.years}</option>)
            }
        }
        )

        let yyy = [];
        this.state.SeelctWs.map((ws) => {
            if (ws.id_w_s == this.state.DefWs) {
                yyy.push(<option selected value={ws.id_w_s}>{ws.w_s}</option>)
            } else {
                yyy.push(<option value={ws.id_w_s}>{ws.w_s}</option>)
            }
        }
        )

        let CompTable;
        if(window.innerWidth > 500){
            CompTable = require('./MidStudent').default
        }
        else{
            CompTable = require('./MidStudentMobile').default
        }

        this.getWsTeacher()
        return (
            <div>
                 <div className="Select__teacher">
                <div className="top__mobile">
                    <label for="11" className="label__round__mobile"> Учебный год: </label>
                    <select className="round__mobile"  onChange={this.getChangeYear.bind(this)}>
                        {SeelctYear}
                    </select> </div>
                    <div className="bottom__mobile">
              <label for="tableSelect_mobile" className="label__round__mobile"> Семестр: </label>
              <select className="round__mobile" id='tableSelect_mobile'  onChange={this.getChange.bind(this)} id="SelectedGroup">
                       {yyy}
                    </select>
              </div>
                  
                </div>
                <CompTable arrA={this.state.arrA}/>
            </div>
        )
    }
}

